'use client';

import { c as _c } from "react/compiler-runtime";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { overlay } from 'overlay-kit';
import type { Swiper as SwiperTypes } from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useDeviceStore } from '@/store/about/deviceStore';
import VideoModal from './modal/video/VideoModal';
export default function VideoSwiper() {
  const $ = _c(10);
  const deviceType = useDeviceStore(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      src: "https://cdn.aipartner.com/about/about_video_preview.mp4"
    }, {
      src: "https://cdn.aipartner.com/about/about_teaser2.mp4"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const videoInfo = t0;
  const swiperSpace = deviceType === "desktop" ? 72 : 16;
  const onChageVideo = _temp2;
  const videoModal = _temp3;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [Navigation, Pagination];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      prevEl: ".swiper-button.prev",
      nextEl: ".swiper-button.next"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== deviceType) {
    t3 = videoInfo.map(video_0 => <SwiperSlide key={video_0.src} className="slide_item"><div className="video_item"><video preload="auto" autoPlay={true} loop={true} muted={true}><source src={video_0.src} type="video/mp4" /></video><p className="title">공인중개사님의 AI파트너,<br /><strong className="text_primary400">이실장</strong>{deviceType === "mobile" && <>입니다.</>}{deviceType === "desktop" && <>이 찾아갑니다.</>}</p><button className="btn_play" type="button" onClick={() => videoModal(video_0.src)}><i className="icon_play" /></button></div></SwiperSlide>);
    $[3] = deviceType;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="swiper-button prev" />;
    t5 = <div className="swiper-button next" />;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== swiperSpace || $[8] !== t3) {
    t6 = <Swiper modules={t1} slidesPerView="auto" initialSlide={0} spaceBetween={swiperSpace} centeredSlides={true} navigation={t2} pagination={true} watchSlidesProgress={false} className="swiper_video" onSlideChange={onChageVideo}>{t3}{t4}{t5}</Swiper>;
    $[7] = swiperSpace;
    $[8] = t3;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp3(src) {
  overlay.open(t0 => {
    const {
      isOpen,
      close
    } = t0;
    return <VideoModal isOpen={isOpen} close={close} src={src} />;
  });
}
function _temp2(swiper) {
  const activeIndex = swiper.activeIndex;
  swiper.slides.forEach(async (slide, index) => {
    const video = slide.querySelector("video");
    if (!video) {
      return;
    }
    if (index === activeIndex) {
      ;
      try {
        video.currentTime = 0;
        await video.play();
      } catch (t0) {
        const error = t0;
        console.error("Video play error:", error);
      }
    } else {
      video.pause();
      video.currentTime = 0;
    }
  });
}
function _temp(state) {
  return state.deviceType;
}